import {axiosInstance} from "./base";

export const getIdps = () => axiosInstance.get('/api/v1/idps');

export const getIAMSmartAuthorizeUrl = () => axiosInstance.get('/api/v1/auth/iamsmart/authorize');
export const getIAMSmartToken = (code) => axiosInstance.post('/api/v1/auth/iamsmart/token', {
	code,
});

export const getFacebookAuthorizeUrl = (state) => axiosInstance.get('/api/v1/auth/facebook/authorize?state=' + state);
export const getFacebookToken = (code) => axiosInstance.post('/api/v1/auth/facebook/token', {
	code,
});
export const getFacebookUserId = (access_token) => axiosInstance.post('/api/v1/auth/facebook/userid', {
	access_token,
});

export const getLinkedInAuthorizeUrl = (state) => axiosInstance.get('/api/v1/auth/linkedin/authorize?state=' + state);
export const getLinkedInToken = (code) => axiosInstance.post('/api/v1/auth/linkedin/token', {
	code,
});
export const getLinkedInUser = (access_token) => axiosInstance.post('/api/v1/auth/linkedin/user', {
	access_token,
});

export const getGoogleAuthorizeUrl = (state) => axiosInstance.get('/api/v1/auth/google/authorize?state=' + state);
export const getGoogleToken = (code) => axiosInstance.post('/api/v1/auth/google/token', {
	code,
});

export const getAppleAuthorizeUrl = (state) => axiosInstance.get('/api/v1/auth/apple/authorize?state=' + state);
export const getAppleToken = (code) => axiosInstance.post('/api/v1/auth/apple/token', {
	code,
});

